export type AccountView = { displayName: string; secondary: string | null; initials: string | null; interactive: boolean };

const present = (v: string | null | undefined): string | null => (v?.trim() ? v.trim() : null);
const letterOf = (v: string): string | null => v.match(/\p{L}|\p{N}/u)?.[0]?.toUpperCase() ?? null;

const initialsOf = (name: string | null, email: string | null): string | null => {
    if (!name) return email ? letterOf(email) : null;
    const letters = name.split(/\s+/).map(letterOf).filter((l): l is string => l !== null);
    if (letters.length === 0) return null;
    return letters.length === 1 ? letters[0]! : `${letters[0]}${letters[letters.length - 1]}`;
};

/** What the account block says — decided once, so the sidebar and the phone drawer agree. */
export const accountView = ({ name, email, canSignOut }: { name: string | null | undefined; email: string | null | undefined; canSignOut: boolean }): AccountView => {
    const realName = present(name);
    const realEmail = present(email);
    const displayName = realName ?? realEmail ?? 'Signed in';
    return { displayName, secondary: realEmail && realEmail !== displayName ? realEmail : null, initials: initialsOf(realName, realEmail), interactive: canSignOut };
};
